var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applicationListField"},[_vm._m(0),_c('div',{staticClass:"right"},[_c('img',{attrs:{"src":_vm.itemData.icon,"alt":""}}),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.itemData.name))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"check"},[_c('input',{attrs:{"type":"checkbox"}})])
}]

export { render, staticRenderFns }